(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6470],{

/***/ 69308:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
}), 'LocationOn');
exports.Z = _default;

/***/ }),

/***/ 23370:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}(this,(()=>{return t={705:t=>{t.exports=function(t,e){const h=[];return 0===e.length?h.push({text:t,highlight:!1}):e[0][0]>0&&h.push({text:t.slice(0,e[0][0]),highlight:!1}),e.forEach(((i,o)=>{const s=i[0],r=i[1];h.push({text:t.slice(s,r),highlight:!0}),o===e.length-1?r<t.length&&h.push({text:t.slice(r,t.length),highlight:!1}):r<e[o+1][0]&&h.push({text:t.slice(r,e[o+1][0]),highlight:!1})})),h}}},e={},function h(i){var o=e[i];if(void 0!==o)return o.exports;var s=e[i]={exports:{}};return t[i](s,s.exports,h),s.exports}(705);var t,e}));

/***/ }),

/***/ 11752:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(62156)


/***/ }),

/***/ 44414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ GoogleMapsAutoComplete; }
/* harmony export */ });
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27812);
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16835);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(80822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68239);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(22430);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(50135);
/* harmony import */ var _mui_material_Autocomplete__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(23776);
/* harmony import */ var _mui_icons_material_LocationOn__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(69308);
/* harmony import */ var _mui_material_Grid__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(86886);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(15861);
/* harmony import */ var autosuggest_highlight_parse__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23370);
/* harmony import */ var autosuggest_highlight_parse__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(autosuggest_highlight_parse__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mui_material_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57144);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(94054);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(56815);
/* harmony import */ var _TextField_TextField__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14491);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
















function loadScript(src, position, id) {
  if (!position) {
    return;
  }

  var script = document.createElement('script');
  script.setAttribute('async', '');
  script.setAttribute('id', id);
  script.src = src;
  position.appendChild(script);
}

var autocompleteService = {
  current: null
};
function GoogleMapsAutoComplete(props) {
  var _React$useState = react__WEBPACK_IMPORTED_MODULE_1__.useState(props.value ? props.value : null),
      _React$useState2 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_React$useState, 2),
      value = _React$useState2[0],
      setValue = _React$useState2[1];

  var _React$useState3 = react__WEBPACK_IMPORTED_MODULE_1__.useState(''),
      _React$useState4 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_React$useState3, 2),
      inputValue = _React$useState4[0],
      setInputValue = _React$useState4[1];

  var _React$useState5 = react__WEBPACK_IMPORTED_MODULE_1__.useState([]),
      _React$useState6 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_React$useState5, 2),
      options = _React$useState6[0],
      setOptions = _React$useState6[1];

  var loaded = react__WEBPACK_IMPORTED_MODULE_1__.useRef(false);
  var darkTheme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    palette: {
      mode: 'dark'
    }
  });
  var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(); // added hardcoded api key to attempt to fix dev/test deploys
  // TODO: remove and get new token once network issue resolved

  var googleApiKeyHC = "AIzaSyAApCIYwA9Xuu10bjI-AN-hRAcgeH3Ef_M";

  if ( true && !loaded.current) {
    if (!document.querySelector('#google-maps')) {
      loadScript("https://maps.googleapis.com/maps/api/js?key=".concat(googleApiKeyHC, "&libraries=places"), document.querySelector('head'), 'google-maps');
    }

    loaded.current = true;
  }

  var fetch = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(function () {
    return (0,_mui_material_utils__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function (request, callback) {
      autocompleteService.current.getPlacePredictions(request, callback);
    }, 400);
  }, []);
  react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function () {
    var active = true;

    if (!autocompleteService.current && window.google) {
      autocompleteService.current = new window.google.maps.places.AutocompleteService();
    }

    if (!autocompleteService.current) {
      return undefined;
    }

    if (inputValue === '') {
      setOptions(value ? [value] : []);
      return undefined;
    }

    fetch({
      input: inputValue
    }, function (results) {
      if (active) {
        var newOptions = [];

        if (value) {
          newOptions = [value];
        }

        if (results) {
          newOptions = [].concat((0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(newOptions), (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(results));
        }

        setOptions(newOptions);
      }
    });
    return function () {
      active = false;
    };
  }, [value, inputValue, fetch]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
    theme: props.newUIUXStyle ? darkTheme : theme,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
      fullWidth: true,
      error: props.error ? true : false,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_mui_material_Autocomplete__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        id: props.id,
        getOptionLabel: function getOptionLabel(option) {
          return typeof option === 'string' ? option : option.description;
        },
        filterOptions: function filterOptions(x) {
          return x;
        },
        options: options,
        autoComplete: true,
        includeInputInList: true,
        filterSelectedOptions: true,
        value: value,
        noOptionsText: "No locations",
        onChange: function onChange(event, newValue) {
          setOptions(newValue ? [newValue].concat((0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(options)) : options);
          setValue(newValue);
          if (props.onChange) props.onChange(newValue);
        },
        onInputChange: function onInputChange(event, newInputValue) {
          setInputValue(newInputValue);
        },
        onBlur: function onBlur() {
          if (props.onBlur) props.onBlur();
        },
        renderInput: function renderInput(params) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
            children: props.newUIUXStyle ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_TextField_TextField__WEBPACK_IMPORTED_MODULE_3__/* .TextField */ .n, _objectSpread(_objectSpread({}, params), {}, {
              size: "md",
              placeholder: "Start typing address",
              fullWidth: true,
              error: props.error ? true : false
            })) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, _objectSpread(_objectSpread({}, params), {}, {
              label: "Venue Street Address",
              fullWidth: true,
              error: props.error ? true : false
            }))
          });
        },
        renderOption: function renderOption(props, option) {
          var matches = option.structured_formatting.main_text_matched_substrings || [];
          var parts = autosuggest_highlight_parse__WEBPACK_IMPORTED_MODULE_2___default()(option.structured_formatting.main_text, matches.map(function (match) {
            return [match.offset, match.offset + match.length];
          }));
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("li", _objectSpread(_objectSpread({}, props), {}, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP, {
              container: true,
              alignItems: "center",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP, {
                item: true,
                sx: {
                  display: 'flex',
                  width: 44
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_mui_icons_material_LocationOn__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                  sx: {
                    color: 'text.secondary'
                  }
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP, {
                item: true,
                sx: {
                  width: 'calc(100% - 44px)',
                  wordWrap: 'break-word'
                },
                children: [parts.map(function (part, index) {
                  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                    component: "span",
                    sx: {
                      fontWeight: part.highlight ? 'bold' : 'regular'
                    },
                    children: part.text
                  }, index);
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                  variant: "body2",
                  color: "text.secondary",
                  children: option.structured_formatting.secondary_text
                })]
              })]
            })
          }));
        }
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
        children: props.helperText
      })]
    })
  });
}

/***/ }),

/***/ 61975:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ AccessibilityContainer; },
/* harmony export */   "x": function() { return /* binding */ TagContainer; }
/* harmony export */ });
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90948);

var AccessibilityContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("div")(function (_ref) {
  var theme = _ref.theme;
  return {
    display: "flex",
    width: theme.space._1300,
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.space._500,
    alignSelf: "stretch",
    "@media (max-width: 600px)": {
      width: "100%"
    }
  };
});
var TagContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("div")(function (_ref2) {
  var theme = _ref2.theme;
  return {
    display: "flex",
    alignItems: "flex-start",
    alignContent: "flex-start",
    gap: theme.space._200,
    alignSelf: "stretch",
    flexWrap: "wrap"
  };
});

/***/ }),

/***/ 76087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ ComponentWithRouter; }
/* harmony export */ });
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(27812);
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(16835);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33609);
/* harmony import */ var _pages_Register_Register_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85614);
/* harmony import */ var _Accessibility_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61975);
/* harmony import */ var _contexts_RegisterContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72078);
/* harmony import */ var _ButtonSwitch_ButtonSwitch__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83274);
/* harmony import */ var src_models_Accessibility__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1967);
/* harmony import */ var src_models_FieldLengths__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50264);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85893);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var Accessibility = function Accessibility(_ref) {
  var onNextButtonClick = _ref.onNextButtonClick,
      onPrevButtonClick = _ref.onPrevButtonClick;

  var _useRegisterContext = (0,_contexts_RegisterContext__WEBPACK_IMPORTED_MODULE_6__/* .useRegisterContext */ .$)(),
      registerInfo = _useRegisterContext.registerInfo,
      setRegisterInfo = _useRegisterContext.setRegisterInfo,
      isAccessibilitySet = _useRegisterContext.isAccessibilitySet,
      setIsAccessibilitySet = _useRegisterContext.setIsAccessibilitySet;

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_1__.useState(registerInfo.user.accessibility !== null ? true : false),
      _React$useState2 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_React$useState, 2),
      isAccessibility = _React$useState2[0],
      setIsAccessibility = _React$useState2[1];

  var isNextButtonDisabled = function isNextButtonDisabled() {
    if (!isAccessibilitySet) {
      return true;
    }

    if (isAccessibility && !registerInfo.user.accessibility && !registerInfo.user.otherAccessibility) {
      return true;
    }

    return false;
  };

  var onOtherAccessibilityChange = function onOtherAccessibilityChange(event) {
    if (event.target.value.trim().length > 0) {
      setRegisterInfo(function (prevRegisterInfo) {
        return _objectSpread(_objectSpread({}, prevRegisterInfo), {}, {
          user: _objectSpread(_objectSpread({}, prevRegisterInfo.user), {}, {
            accessibility: "Other",
            otherAccessibility: event.target.value
          })
        });
      });
    } else {
      setRegisterInfo(function (prevRegisterInfo) {
        return _objectSpread(_objectSpread({}, prevRegisterInfo), {}, {
          user: _objectSpread(_objectSpread({}, prevRegisterInfo.user), {}, {
            accessibility: null,
            otherAccessibility: null
          })
        });
      });
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_Accessibility_styles__WEBPACK_IMPORTED_MODULE_5__/* .AccessibilityContainer */ .K, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(___WEBPACK_IMPORTED_MODULE_3__/* .TitleSubtitle */ .V9, {
      size: "sm",
      title: "Any Accessibility Requirements?",
      subTitle: "We need to ensure the venue has the appropriate set up for you."
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_ButtonSwitch_ButtonSwitch__WEBPACK_IMPORTED_MODULE_7__/* .ButtonSwitch */ .i, {
      leftButtonChildren: "Yes",
      rightButtonChildren: "No",
      active: isAccessibilitySet ? registerInfo.user.accessibility !== null ? "left" : "right" : undefined,
      onLeftButtonClick: function onLeftButtonClick() {
        setIsAccessibilitySet(true);
        setIsAccessibility(true);
      },
      onRightButtonClick: function onRightButtonClick() {
        setIsAccessibilitySet(true);
        setIsAccessibility(false);
      }
    }), isAccessibilitySet && isAccessibility && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_Accessibility_styles__WEBPACK_IMPORTED_MODULE_5__/* .TagContainer */ .x, {
        children: (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(src_models_Accessibility__WEBPACK_IMPORTED_MODULE_8__/* .accessibilityOptionsMap */ .ku).map(function (_ref2) {
          var _ref3 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_ref2, 2),
              key = _ref3[0],
              value = _ref3[1];

          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(___WEBPACK_IMPORTED_MODULE_3__/* .Tag */ .Vp, {
            label: value,
            isActive: registerInfo.user.accessibility === key,
            isControlled: true,
            onClick: function onClick() {
              setRegisterInfo(function (prevRegisterInfo) {
                return _objectSpread(_objectSpread({}, prevRegisterInfo), {}, {
                  user: _objectSpread(_objectSpread({}, prevRegisterInfo.user), {}, {
                    accessibility: key
                  })
                });
              });
            },
            onDelete: function onDelete() {
              setRegisterInfo(function (prevRegisterInfo) {
                return _objectSpread(_objectSpread({}, prevRegisterInfo), {}, {
                  user: _objectSpread(_objectSpread({}, prevRegisterInfo.user), {}, {
                    accessibility: null,
                    otherAccessibility: null
                  })
                });
              });
            }
          });
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(___WEBPACK_IMPORTED_MODULE_3__/* .TextField */ .nv, {
        fullWidth: true,
        label: "Other",
        placeholder: "Please Specify",
        value: registerInfo.user.otherAccessibility,
        onChange: onOtherAccessibilityChange,
        inputProps: {
          maxLength: src_models_FieldLengths__WEBPACK_IMPORTED_MODULE_9__/* .FieldLengths.user.otherAccessibility */ .t.user.otherAccessibility
        },
        helperText: (0,src_models_FieldLengths__WEBPACK_IMPORTED_MODULE_9__/* .otherAccessibilityCounter */ .s)(registerInfo.user.otherAccessibility)
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_pages_Register_Register_styles__WEBPACK_IMPORTED_MODULE_4__/* .CTABackAndForthContainer */ .uF, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(___WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
        size: "md",
        variant: "tertiary",
        onClick: function onClick() {
          return onPrevButtonClick();
        },
        "data-cy": "button-booking-next",
        sx: {
          padding: 0
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_pages_Register_Register_styles__WEBPACK_IMPORTED_MODULE_4__/* .ButtonContainer */ .qO, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_pages_Register_Register_styles__WEBPACK_IMPORTED_MODULE_4__/* .ButtonIcon */ .Ei, {
            icon: "ArrowLeft"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_pages_Register_Register_styles__WEBPACK_IMPORTED_MODULE_4__/* .ButtonLabel */ .aN, {
            children: "Back"
          })]
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(___WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
        "data-cy": "register-accessibility-submit",
        onClick: function onClick() {
          return onNextButtonClick();
        },
        disabled: isNextButtonDisabled(),
        children: " Continue "
      })]
    })]
  });
};

Accessibility.displayName = "Accessibility";
var ComponentWithRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.withRouter)(Accessibility);


/***/ }),

/***/ 21492:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* binding */ ComponentWithRouter; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/index.ts + 107 modules
var components = __webpack_require__(33609);
// EXTERNAL MODULE: ./src/pages/Register/Register.styles.ts
var Register_styles = __webpack_require__(85614);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
;// CONCATENATED MODULE: ./src/components/Register/Address/Address.styles.ts

var CreateAddressContainer = (0,styled/* default */.ZP)("div")(function (_ref) {
  var theme = _ref.theme;
  return {
    display: "flex",
    width: theme.space._1300,
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.space._500,
    alignSelf: "stretch",
    "@media (max-width: 600px)": {
      width: "100%"
    }
  };
});
var EmailPreferenceContainer = (0,styled/* default */.ZP)("div")(function (_ref2) {
  var theme = _ref2.theme;
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.space._300,
    alignSelf: "stretch"
  };
});
var EmailPreferenceTitle = (0,styled/* default */.ZP)("div")(function (_ref3) {
  var theme = _ref3.theme;
  return {
    color: theme.colors["neutral.400"],
    fontSize: theme.fontSizes.sm,
    fontFamily: theme.fonts["default"],
    fontWeight: theme.fontWeights.regular,
    lineHeight: theme.lineHeights.base
  };
});
var EmailPreferenceSubTitle = (0,styled/* default */.ZP)("div")(function (_ref4) {
  var theme = _ref4.theme;
  return {
    color: theme.colors["neutral.500"],
    fontSize: theme.fontSizes.xs,
    fontFamily: theme.fonts["default"],
    fontWeight: theme.fontWeights.regular,
    lineHeight: theme.lineHeights.base
  };
});
// EXTERNAL MODULE: ./src/components/GoogleMapsAutoComplete/GoogleMapsAutoComplete.tsx
var GoogleMapsAutoComplete = __webpack_require__(44414);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./src/contexts/RegisterContext.tsx
var RegisterContext = __webpack_require__(72078);
// EXTERNAL MODULE: ./src/utils/google-location.tsx
var google_location = __webpack_require__(2892);
// EXTERNAL MODULE: ./src/components/ButtonSwitch/ButtonSwitch.tsx + 2 modules
var ButtonSwitch = __webpack_require__(83274);
// EXTERNAL MODULE: ./src/components/Tooltip/Tooltip.tsx + 2 modules
var Tooltip = __webpack_require__(67932);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Register/Address/Address.tsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
















var Address = function Address(_ref) {
  var onNextButtonClick = _ref.onNextButtonClick,
      onPrevButtonClick = _ref.onPrevButtonClick;

  var _useRegisterContext = (0,RegisterContext/* useRegisterContext */.$)(),
      registerInfo = _useRegisterContext.registerInfo,
      setRegisterInfo = _useRegisterContext.setRegisterInfo,
      googleAddress = _useRegisterContext.googleAddress,
      setGoogleAddress = _useRegisterContext.setGoogleAddress;

  var _useState = (0,react.useState)(false),
      addressValidationError = _useState[0],
      setAddressValidationError = _useState[1];

  var _useState2 = (0,react.useState)(""),
      addressValidationErrorMessage = _useState2[0],
      setAddressValidationErrorMessage = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      loading = _useState3[0],
      setLoading = _useState3[1];

  var _getConfig = config_default()(),
      publicRuntimeConfig = _getConfig.publicRuntimeConfig;

  var onAddressChange = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(value) {
      var registerAddress;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading(true);
              setGoogleAddress(value);
              registerAddress = {
                latitude: null,
                longitude: null,
                longLocation: null,
                shortLocation: null,
                detailsJson: null,
                country: "",
                unitOrApartmentNumber: null,
                street: "",
                suburb: null,
                state: null,
                postCode: ""
              };
              _context.next = 5;
              return (0,google_location/* setGeocoderInfo */.j)(value, registerAddress);

            case 5:
              setRegisterInfo(function (prevRegisterInfo) {
                return _objectSpread(_objectSpread({}, prevRegisterInfo), {}, {
                  address: registerAddress
                });
              });
              setLoading(false);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onAddressChange(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleNextButtonClick = function handleNextButtonClick() {
    setAddressValidationError(false);

    if (!registerInfo.address.street) {
      setAddressValidationError(true);
      setAddressValidationErrorMessage("Street is mandatory");
      return;
    }

    onNextButtonClick();
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(CreateAddressContainer, {
    "data-cy-pageloading": loading,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* TitleSubtitle */.V9, {
      size: "sm",
      title: "Your Neck of the Woods",
      subTitle: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: ["Don't worry, we won't show up at your door. There's an ", /*#__PURE__*/(0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
          tooltipName: "appearanceReleaseAndNDA",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Register_styles/* StyledBlueSpan */.gj, {
            children: "Appearance Release and NDA"
          })
        }), " in the Terms and Conditions for each show."]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(GoogleMapsAutoComplete/* default */.Z, {
      id: "google-maps-autocomplete",
      apiKey: publicRuntimeConfig.googleMapsApiKey,
      value: googleAddress,
      onChange: onAddressChange,
      newUIUXStyle: true,
      "data-cy": "modal-shootinglocation-location"
    }), addressValidationError && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* InfoMessage */.$J, {
      variant: "error",
      hasBackground: true,
      message: addressValidationErrorMessage
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(EmailPreferenceContainer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(EmailPreferenceTitle, {
        children: "Email me about future shows filming:"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonSwitch/* ButtonSwitch */.i, {
        leftButtonChildren: "Countrywide",
        rightButtonChildren: "In My City",
        active: registerInfo.user.emailPreferences === "AustraliaWide" ? "left" : "right",
        onLeftButtonClick: function onLeftButtonClick() {
          setRegisterInfo(function (prevRegisterInfo) {
            return _objectSpread(_objectSpread({}, prevRegisterInfo), {}, {
              user: _objectSpread(_objectSpread({}, prevRegisterInfo.user), {}, {
                emailPreferences: "AustraliaWide"
              })
            });
          });
        },
        onRightButtonClick: function onRightButtonClick() {
          setRegisterInfo(function (prevRegisterInfo) {
            return _objectSpread(_objectSpread({}, prevRegisterInfo), {}, {
              user: _objectSpread(_objectSpread({}, prevRegisterInfo.user), {}, {
                emailPreferences: "InState"
              })
            });
          });
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(EmailPreferenceSubTitle, {
        children: "We only email about upcoming shows. You can unsubscribe easily at any time."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Register_styles/* CTABackAndForthContainer */.uF, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
        size: "md",
        variant: "tertiary",
        onClick: function onClick() {
          return onPrevButtonClick();
        },
        "data-cy": "button-booking-next",
        sx: {
          padding: 0
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Register_styles/* ButtonContainer */.qO, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Register_styles/* ButtonIcon */.Ei, {
            icon: "ArrowLeft"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Register_styles/* ButtonLabel */.aN, {
            children: "Back"
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
        "data-cy": "register-address-submit",
        onClick: handleNextButtonClick,
        disabled: googleAddress == null,
        children: " Continue "
      })]
    })]
  });
};

Address.displayName = "Address";
var ComponentWithRouter = (0,router.withRouter)(Address);


/***/ }),

/***/ 43696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LA": function() { return /* binding */ FieldsContainer; },
/* harmony export */   "d0": function() { return /* binding */ DateTextField; },
/* harmony export */   "nC": function() { return /* binding */ DateOfBirthContainer; }
/* harmony export */ });
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90948);
/* harmony import */ var _NumericTextField_NumericTextField__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81249);


var DateOfBirthContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)("div")(function (_ref) {
  var theme = _ref.theme;
  return {
    display: "flex",
    width: theme.space._1300,
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.space._500,
    alignSelf: "stretch",
    "@media (max-width: 600px)": {
      width: "100%"
    }
  };
});
var FieldsContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)("div")(function (_ref2) {
  var theme = _ref2.theme;
  return {
    display: "flex",
    alignItems: "flex-start",
    gap: theme.space._400,
    alignSelf: "stretch"
  };
});
var DateTextField = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_NumericTextField_NumericTextField__WEBPACK_IMPORTED_MODULE_0__/* .NumericTextField */ ._)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.space._200,
    flex: "1 0 0"
  };
});

/***/ }),

/***/ 44404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ ComponentWithRouter; }
/* harmony export */ });
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33609);
/* harmony import */ var _contexts_RegisterContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72078);
/* harmony import */ var _pages_Register_Register_styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85614);
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15443);
/* harmony import */ var _Tooltip_Tooltip__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67932);
/* harmony import */ var _DateOfBirth_styles__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(43696);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var DateOfBirth = function DateOfBirth(_ref) {
  var onNextButtonClick = _ref.onNextButtonClick,
      onPrevButtonClick = _ref.onPrevButtonClick;

  var _useRegisterContext = (0,_contexts_RegisterContext__WEBPACK_IMPORTED_MODULE_5__/* .useRegisterContext */ .$)(),
      registerInfo = _useRegisterContext.registerInfo,
      setRegisterInfo = _useRegisterContext.setRegisterInfo;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(),
      day = _useState[0],
      setDay = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(),
      month = _useState2[0],
      setMonth = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(),
      year = _useState3[0],
      setYear = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      isDateValid = _useState4[0],
      setIsDateValid = _useState4[1];

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
    if (!registerInfo.user.dateOfBirth) {
      return;
    }

    var registerInfodateOfBirth = new Date(registerInfo.user.dateOfBirth);
    var registerInfoDay = registerInfodateOfBirth.getUTCDate();
    var registerInfoMonth = registerInfodateOfBirth.getUTCMonth() + 1;
    var registerInfoYear = registerInfodateOfBirth.getUTCFullYear();
    setDay(registerInfoDay);
    setMonth(registerInfoMonth);
    setYear(registerInfoYear);
    validateAndSetDate(registerInfoYear, registerInfoMonth, registerInfoDay);
  }, []);

  var validateAndSetDate = function validateAndSetDate(year, month, day) {
    if (!year || !month || !day) {
      setIsDateValid(false);
      return;
    }

    var date = new Date(Date.UTC(year, month - 1, day, 0, 0, 0, 0));

    if ((0,_utils_dates__WEBPACK_IMPORTED_MODULE_7__/* .validateBirthDate */ .Dr)(year, month, day)) {
      setIsDateValid(true);
      setRegisterInfo(function (prevRegisterInfo) {
        return _objectSpread(_objectSpread({}, prevRegisterInfo), {}, {
          user: _objectSpread(_objectSpread({}, prevRegisterInfo.user), {}, {
            dateOfBirth: dayjs__WEBPACK_IMPORTED_MODULE_1___default()(date).toISOString()
          })
        });
      });
    } else {
      setIsDateValid(false);
      return;
    }
  };

  var onDayChange = function onDayChange(value) {
    setDay(value);
    validateAndSetDate(year, month, value);
  };

  var onMonthChange = function onMonthChange(value) {
    setMonth(value);
    validateAndSetDate(year, value, day);
  };

  var onYearChange = function onYearChange(value) {
    setYear(value);
    validateAndSetDate(value, month, day);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_DateOfBirth_styles__WEBPACK_IMPORTED_MODULE_9__/* .DateOfBirthContainer */ .nC, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(___WEBPACK_IMPORTED_MODULE_4__/* .TitleSubtitle */ .V9, {
      "data-cy": "register-date-of-birth-title",
      size: "sm",
      title: "My date of birth is...",
      subTitle: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.Fragment, {
        children: ["Please put your correct birthdate. To book tickets you must be over the age of 18. ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_Tooltip_Tooltip__WEBPACK_IMPORTED_MODULE_8__/* .Tooltip */ .u, {
          tooltipName: "whatIfImUnderAge",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_pages_Register_Register_styles__WEBPACK_IMPORTED_MODULE_6__/* .StyledBlueSpan */ .gj, {
            children: "What if I'm under 18?"
          })
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_DateOfBirth_styles__WEBPACK_IMPORTED_MODULE_9__/* .FieldsContainer */ .LA, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_DateOfBirth_styles__WEBPACK_IMPORTED_MODULE_9__/* .DateTextField */ .d0, {
        "data-cy": "register-date-of-birth-day",
        placeholder: "DD",
        value: day,
        onChange: onDayChange,
        InputProps: {
          inputProps: {
            min: 0
          }
        }
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_DateOfBirth_styles__WEBPACK_IMPORTED_MODULE_9__/* .DateTextField */ .d0, {
        "data-cy": "register-date-of-birth-month",
        placeholder: "MM",
        value: month,
        onChange: onMonthChange,
        InputProps: {
          inputProps: {
            min: 0
          }
        }
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_DateOfBirth_styles__WEBPACK_IMPORTED_MODULE_9__/* .DateTextField */ .d0, {
        "data-cy": "register-date-of-birth-year",
        placeholder: "YYYY",
        value: year,
        onChange: onYearChange,
        InputProps: {
          inputProps: {
            min: 0
          }
        }
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_pages_Register_Register_styles__WEBPACK_IMPORTED_MODULE_6__/* .CTABackAndForthContainer */ .uF, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(___WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zx, {
        size: "md",
        variant: "tertiary",
        onClick: function onClick() {
          return onPrevButtonClick();
        },
        "data-cy": "button-booking-next",
        sx: {
          padding: 0
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_pages_Register_Register_styles__WEBPACK_IMPORTED_MODULE_6__/* .ButtonContainer */ .qO, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_pages_Register_Register_styles__WEBPACK_IMPORTED_MODULE_6__/* .ButtonIcon */ .Ei, {
            icon: "ArrowLeft"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_pages_Register_Register_styles__WEBPACK_IMPORTED_MODULE_6__/* .ButtonLabel */ .aN, {
            children: "Back"
          })]
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(___WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zx, {
        "data-cy": "register-date-of-birth-submit",
        onClick: function onClick() {
          return onNextButtonClick();
        },
        disabled: !isDateValid,
        children: " Continue "
      })]
    })]
  });
};

DateOfBirth.displayName = "DateOfBirth";
var ComponentWithRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.withRouter)(DateOfBirth);


/***/ }),

/***/ 98361:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ ComponentWithRouter; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/index.ts + 107 modules
var components = __webpack_require__(33609);
// EXTERNAL MODULE: ./src/pages/Register/Register.styles.ts
var Register_styles = __webpack_require__(85614);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
;// CONCATENATED MODULE: ./src/components/Register/Gender/Gender.styles.ts

var GenderContainer = (0,styled/* default */.ZP)("div")(function (_ref) {
  var theme = _ref.theme;
  return {
    display: "flex",
    width: theme.space._1300,
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.space._500,
    alignSelf: "stretch",
    "@media (max-width: 600px)": {
      width: "100%"
    }
  };
});
// EXTERNAL MODULE: ./src/contexts/RegisterContext.tsx
var RegisterContext = __webpack_require__(72078);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Register/Gender/Gender.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var Gender = function Gender(_ref) {
  var onNextButtonClick = _ref.onNextButtonClick,
      onPrevButtonClick = _ref.onPrevButtonClick;

  var _useRegisterContext = (0,RegisterContext/* useRegisterContext */.$)(),
      registerInfo = _useRegisterContext.registerInfo,
      setRegisterInfo = _useRegisterContext.setRegisterInfo;

  var setGender = function setGender(gender) {
    setRegisterInfo(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        user: _objectSpread(_objectSpread({}, prev.user), {}, {
          gender: gender
        })
      });
    });
  };

  var isNextButtonDisabled = !registerInfo.user.gender;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(GenderContainer, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* TitleSubtitle */.V9, {
      size: "sm",
      title: "Your Gender?",
      subTitle: "So we can address you correctly in any communications."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* GenderSelector */.Lk, {
      value: registerInfo.user.gender,
      onChange: setGender
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Register_styles/* CTABackAndForthContainer */.uF, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
        size: "md",
        variant: "tertiary",
        onClick: function onClick() {
          return onPrevButtonClick();
        },
        "data-cy": "button-booking-next",
        sx: {
          padding: 0
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Register_styles/* ButtonContainer */.qO, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Register_styles/* ButtonIcon */.Ei, {
            icon: "ArrowLeft"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Register_styles/* ButtonLabel */.aN, {
            children: "Back"
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
        "data-cy": "register-gender-submit",
        onClick: function onClick() {
          return onNextButtonClick();
        },
        disabled: isNextButtonDisabled,
        children: " Continue "
      })]
    })]
  });
};

Gender.displayName = "Gender";
var ComponentWithRouter = (0,router.withRouter)(Gender);


/***/ }),

/***/ 91610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": function() { return /* binding */ ComponentWithRouter; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/index.ts + 107 modules
var components = __webpack_require__(33609);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./src/icons/index.ts
var icons = __webpack_require__(46409);
;// CONCATENATED MODULE: ./src/components/Register/Password/Password.styles.ts



var CreatePasswordContainer = (0,styled/* default */.ZP)("div")(function (_ref) {
  var theme = _ref.theme;
  return {
    display: "flex",
    width: theme.space._1300,
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.space._500,
    alignSelf: "stretch",
    "@media (max-width: 600px)": {
      width: "100%"
    }
  };
});
var PasswordRuleContainer = (0,styled/* default */.ZP)("div")(function (_ref2) {
  var theme = _ref2.theme;
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.space._100,
    alignSelf: "stretch"
  };
});
var PasswordRule = (0,styled/* default */.ZP)("div")(function (_ref3) {
  var theme = _ref3.theme;
  return {
    display: "flex",
    alignItems: "center",
    gap: theme.space._200,
    alignSelf: "stretch",
    '&.is-checked div': {
      color: theme.colors["lime.500"]
    },
    '&.is-checked p': {
      color: theme.colors["lime.500"]
    }
  };
});
var PasswordRuleIcon = (0,styled/* default */.ZP)(icons/* Icon */.J)(function (_ref4) {
  var theme = _ref4.theme;
  return {
    width: theme.space._400,
    height: theme.space._400,
    color: theme.colors["pink.400"]
  };
});
var EyeIconContainer = (0,styled/* default */.ZP)("span")(function (_ref5) {
  var theme = _ref5.theme;
  return {
    color: theme.colors["neutral.400"],
    cursor: "pointer",
    pointerEvents: "auto"
  };
});
var PasswordRuleText = (0,styled/* default */.ZP)(Typography/* default */.Z)(function (_ref6) {
  var theme = _ref6.theme;
  return {
    color: theme.colors["neutral.50"],
    fontSize: theme.fontSizes.sm,
    fontFamily: theme.fonts["default"],
    fontWeight: theme.fontWeights.regular,
    lineHeight: theme.lineHeights.base
  };
});
// EXTERNAL MODULE: ./src/pages/Register/Register.styles.ts
var Register_styles = __webpack_require__(85614);
// EXTERNAL MODULE: ./src/contexts/RegisterContext.tsx
var RegisterContext = __webpack_require__(72078);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Register/Password/Password.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var Password = function Password(_ref) {
  var onNextButtonClick = _ref.onNextButtonClick;
  var atLeastOneLetter = /^.*[A-Za-z].*$/;
  var atLeastOneNumber = /^.*\d.*$/;
  var atLeastOneSpecialCharacter = /^.*[!@#$%^&*=?].*$/;
  var between8and16CharactersLong = /^.{8,16}$/;

  var _useRegisterContext = (0,RegisterContext/* useRegisterContext */.$)(),
      registerInfo = _useRegisterContext.registerInfo,
      setRegisterInfo = _useRegisterContext.setRegisterInfo;

  var _useState = (0,react.useState)(atLeastOneLetter.test(registerInfo.user.password)),
      isAtLeastOneLetter = _useState[0],
      setIsAtLeastOneLetter = _useState[1];

  var _useState2 = (0,react.useState)(atLeastOneNumber.test(registerInfo.user.password)),
      isAtLeastOneNumber = _useState2[0],
      setIsAtLeastOneNumber = _useState2[1];

  var _useState3 = (0,react.useState)(atLeastOneSpecialCharacter.test(registerInfo.user.password)),
      isAtLeastOneSpecialCharacter = _useState3[0],
      setIsAtLeastOneSpecialCharacter = _useState3[1];

  var _useState4 = (0,react.useState)(between8and16CharactersLong.test(registerInfo.user.password)),
      isBetween8and16CharactersLong = _useState4[0],
      setIsBetween8and16CharactersLong = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      showPassword = _useState5[0],
      setShowPassword = _useState5[1];

  var isContinueButtonDisabled = function isContinueButtonDisabled() {
    return !(isAtLeastOneLetter && isAtLeastOneNumber && isAtLeastOneSpecialCharacter && isBetween8and16CharactersLong);
  };

  var validatePassword = function validatePassword(passwd) {
    setIsAtLeastOneLetter(atLeastOneLetter.test(passwd));
    setIsAtLeastOneNumber(atLeastOneNumber.test(passwd));
    setIsAtLeastOneSpecialCharacter(atLeastOneSpecialCharacter.test(passwd));
    setIsBetween8and16CharactersLong(between8and16CharactersLong.test(passwd));
  };

  var onPasswordChange = function onPasswordChange(event) {
    setRegisterInfo(function (prevRegisterInfo) {
      return _objectSpread(_objectSpread({}, prevRegisterInfo), {}, {
        user: _objectSpread(_objectSpread({}, prevRegisterInfo.user), {}, {
          password: event.target.value
        })
      });
    });
    validatePassword(event.target.value);
  };

  var ShowHidePassword = function ShowHidePassword() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(EyeIconContainer, {
      onClick: function onClick() {
        return setShowPassword(!showPassword);
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* Icon */.J, {
        icon: showPassword ? "EyeOff" : "Eye",
        size: "sm"
      })
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(CreatePasswordContainer, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* TitleSubtitle */.V9, {
      "data-cy": "register-create-password-title",
      size: "sm",
      title: "Create a Password",
      subTitle: "You\u2019ll need this to manage your bookings online"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* TextField */.nv, {
      "data-cy": "register-password",
      autoFocus: true,
      fullWidth: true,
      type: showPassword ? 'text' : 'password',
      placeholder: "Password",
      value: registerInfo.user.password,
      onChange: onPasswordChange,
      rightIcon: /*#__PURE__*/(0,jsx_runtime.jsx)(ShowHidePassword, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PasswordRuleContainer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(PasswordRule, {
        className: isAtLeastOneLetter ? "is-checked" : "",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PasswordRuleIcon, {
          "data-cy": "register-password-one-letter",
          icon: isAtLeastOneLetter ? "Check" : "Plus"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(PasswordRuleText, {
          children: " At least one letter "
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PasswordRule, {
        className: isAtLeastOneNumber ? "is-checked" : "",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PasswordRuleIcon, {
          "data-cy": "register-password-one-number",
          icon: isAtLeastOneNumber ? "Check" : "Plus"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(PasswordRuleText, {
          children: " At least one number "
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PasswordRule, {
        className: isAtLeastOneSpecialCharacter ? "is-checked" : "",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PasswordRuleIcon, {
          "data-cy": "register-password-one-special-character",
          icon: isAtLeastOneSpecialCharacter ? "Check" : "Plus"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(PasswordRuleText, {
          children: " At least one special character (!@#$%^&*=?) "
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PasswordRule, {
        className: isBetween8and16CharactersLong ? "is-checked" : "",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PasswordRuleIcon, {
          "data-cy": "register-password-length",
          icon: isBetween8and16CharactersLong ? "Check" : "Plus"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(PasswordRuleText, {
          children: " Be between 8 - 16 characters long "
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Register_styles/* CTAForthContainer */.Uh, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
        "data-cy": "register-password-submit",
        onClick: function onClick() {
          return onNextButtonClick();
        },
        disabled: isContinueButtonDisabled(),
        children: " Continue "
      })
    })]
  });
};

Password.displayName = "Password";
var ComponentWithRouter = (0,router.withRouter)(Password);


/***/ }),

/***/ 22039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ CustomPhoneInput; },
/* harmony export */   "v": function() { return /* binding */ PhoneNumberContainer; }
/* harmony export */ });
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90948);
/* harmony import */ var react_phone_input_2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67555);
/* harmony import */ var react_phone_input_2__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_phone_input_2__WEBPACK_IMPORTED_MODULE_0__);


var PhoneNumberContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)("div")(function (_ref) {
  var theme = _ref.theme;
  return {
    display: "flex",
    width: theme.space._1300,
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.space._500,
    alignSelf: "stretch",
    "@media (max-width: 600px)": {
      width: "100%"
    }
  };
});
var CustomPhoneInput = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)((react_phone_input_2__WEBPACK_IMPORTED_MODULE_0___default()))(function (_ref2) {
  var theme = _ref2.theme;
  return {
    "& input": {
      border: "1px solid ".concat(theme.colors["neutral.600"], "!important"),
      height: '2rem',
      width: "100%!important",
      backgroundColor: "".concat(theme.colors["neutral.900"], "!important"),
      color: "".concat(theme.colors["neutral.50"], "!important")
    },
    "& ul": {
      backgroundColor: "".concat(theme.colors["neutral.900"], "!important"),
      color: "".concat(theme.colors["neutral.50"], "!important"),
      "& li:hover": {
        backgroundColor: "".concat(theme.colors["neutral.950"], "!important"),
        color: "".concat(theme.colors["white"], "!important"),
        opacity: "1.5!important"
      },
      "& li.highlight": {
        backgroundColor: "".concat(theme.colors["neutral.950"], "!important"),
        color: "".concat(theme.colors["white"], "!important"),
        opacity: "1.5!important"
      }
    }
  };
});

/***/ }),

/***/ 92788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ ComponentWithRouter; }
/* harmony export */ });
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33609);
/* harmony import */ var _pages_Register_Register_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85614);
/* harmony import */ var _PhoneNumber_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22039);
/* harmony import */ var react_phone_input_2_lib_bootstrap_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26497);
/* harmony import */ var react_phone_input_2_lib_bootstrap_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react_phone_input_2_lib_bootstrap_css__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _contexts_RegisterContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72078);
/* harmony import */ var _services_AuthenticationService__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(28148);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












var PhoneNumber = function PhoneNumber(_ref) {
  var onNextButtonClick = _ref.onNextButtonClick,
      onPrevButtonClick = _ref.onPrevButtonClick;

  var _useRegisterContext = (0,_contexts_RegisterContext__WEBPACK_IMPORTED_MODULE_7__/* .useRegisterContext */ .$)(),
      registerInfo = _useRegisterContext.registerInfo,
      setRegisterInfo = _useRegisterContext.setRegisterInfo;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      sendVerificationcodeError = _useState[0],
      setSendVerificationcodeError = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""),
      errorMessage = _useState2[0],
      setErrorMessage = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      loading = _useState3[0],
      setLoading = _useState3[1];

  var handleSendVerificationcode = function handleSendVerificationcode() {
    setLoading(true);
    var confirmPhoneNumberData = {
      email: registerInfo.user.email,
      phoneNumber: registerInfo.user.phoneNumber
    };
    (0,_services_AuthenticationService__WEBPACK_IMPORTED_MODULE_8__/* .sendConfirmPhoneNumberSMS */ .q0)(confirmPhoneNumberData).then(function (res) {
      if (res.status == 400) {
        var _res$errors, _res$errors2;

        setSendVerificationcodeError(true);
        setErrorMessage((_res$errors = res.errors) !== null && _res$errors !== void 0 && _res$errors.message ? (_res$errors2 = res.errors) === null || _res$errors2 === void 0 ? void 0 : _res$errors2.message : "An error occured");
      } else if (res.status == 200) {
        onNextButtonClick();
      }

      setLoading(false);
    });
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(_PhoneNumber_styles__WEBPACK_IMPORTED_MODULE_5__/* .PhoneNumberContainer */ .v, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(___WEBPACK_IMPORTED_MODULE_3__/* .TitleSubtitle */ .V9, {
      size: "sm",
      title: "Mobile Number",
      subTitle: "You will need to reply to an automated SMS to confirm your seat in the studio."
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
      "data-cy": "register-phone-number",
      style: {
        alignSelf: "stretch"
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_PhoneNumber_styles__WEBPACK_IMPORTED_MODULE_5__/* .CustomPhoneInput */ .s, {
        value: registerInfo.user.phoneNumber,
        onChange: function onChange(value) {
          return setRegisterInfo(function (prevRegisterInfo) {
            return _objectSpread(_objectSpread({}, prevRegisterInfo), {}, {
              user: _objectSpread(_objectSpread({}, prevRegisterInfo.user), {}, {
                phoneNumber: "+".concat(value)
              })
            });
          });
        },
        country: "au",
        inputProps: {
          name: 'phone',
          required: true,
          autoFocus: true
        }
      })
    }), sendVerificationcodeError && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(___WEBPACK_IMPORTED_MODULE_3__/* .InfoMessage */ .$J, {
      "data-cy": "register-error",
      variant: "error",
      hasBackground: true,
      message: errorMessage
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(_pages_Register_Register_styles__WEBPACK_IMPORTED_MODULE_4__/* .CTABackAndForthContainer */ .uF, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(___WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
        size: "md",
        variant: "tertiary",
        onClick: function onClick() {
          return onPrevButtonClick();
        },
        "data-cy": "button-booking-next",
        sx: {
          padding: 0
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(_pages_Register_Register_styles__WEBPACK_IMPORTED_MODULE_4__/* .ButtonContainer */ .qO, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_pages_Register_Register_styles__WEBPACK_IMPORTED_MODULE_4__/* .ButtonIcon */ .Ei, {
            icon: "ArrowLeft"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_pages_Register_Register_styles__WEBPACK_IMPORTED_MODULE_4__/* .ButtonLabel */ .aN, {
            children: "Back"
          })]
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(___WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
        "data-cy": "register-phone-number-submit",
        onClick: handleSendVerificationcode,
        disabled: !registerInfo.user.phoneNumber,
        loading: loading,
        children: " Send Verification Code "
      })]
    })]
  });
};

PhoneNumber.displayName = "PhoneNumber";
var ComponentWithRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.withRouter)(PhoneNumber);


/***/ }),

/***/ 81771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LA": function() { return /* binding */ FieldsContainer; },
/* harmony export */   "Vr": function() { return /* binding */ PhoneNumberVerificationContainer; },
/* harmony export */   "df": function() { return /* binding */ ResendCode; },
/* harmony export */   "gj": function() { return /* binding */ StyledBlueSpan; }
/* harmony export */ });
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15861);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90948);


var PhoneNumberVerificationContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("div")(function (_ref) {
  var theme = _ref.theme;
  return {
    display: "flex",
    width: theme.space._1300,
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.space._500,
    alignSelf: "stretch",
    "@media (max-width: 600px)": {
      width: "100%"
    }
  };
});
var FieldsContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("div")(function (_ref2) {
  var theme = _ref2.theme;
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.space._400,
    alignSelf: "stretch"
  };
});
var ResendCode = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    color: theme.colors["neutral.500"],
    textAlign: "center",
    fontSize: theme.fontSizes.sm,
    fontFamily: theme.fonts["default"],
    fontWeight: theme.fontWeights.regular,
    lineHeight: theme.lineHeights.base
  };
});
var StyledBlueSpan = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("span")(function (_ref4) {
  var theme = _ref4.theme;
  return {
    color: theme.colors["blue.400"],
    cursor: "pointer",
    pointerEvents: "auto"
  };
});

/***/ }),

/***/ 61677:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ ComponentWithRouter; }
/* harmony export */ });
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(50029);
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _PhoneNumberVerification_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81771);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33609);
/* harmony import */ var _VerificationCodeInput_VerificationCodeInput__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2595);
/* harmony import */ var _pages_Register_Register_styles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85614);
/* harmony import */ var _contexts_RegisterContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72078);
/* harmony import */ var _services_AuthenticationService__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(28148);
/* harmony import */ var src_contexts_AuthContext__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(82030);
/* harmony import */ var src_utils_string_utils__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(46955);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85893);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















var PhoneNumberVerification = function PhoneNumberVerification(_ref) {
  var onNextButtonClick = _ref.onNextButtonClick,
      onPrevButtonClick = _ref.onPrevButtonClick;
  var inputLength = 6;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      verificationCodeHasError = _useState[0],
      setVerificationCodeHasError = _useState[1];

  var _useRegisterContext = (0,_contexts_RegisterContext__WEBPACK_IMPORTED_MODULE_8__/* .useRegisterContext */ .$)(),
      registerInfo = _useRegisterContext.registerInfo,
      setRegisterInfo = _useRegisterContext.setRegisterInfo;

  var _useAuthContext = (0,src_contexts_AuthContext__WEBPACK_IMPORTED_MODULE_10__/* .useAuthContext */ .E)(),
      setUser = _useAuthContext.setUser;

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      registerProfileError = _useState3[0],
      setRegisterProfileError = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      showInfoMessage = _useState4[0],
      setShowInfoMessage = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""),
      errorMessage = _useState5[0],
      setErrorMessage = _useState5[1];

  var _useState6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""),
      infoMessage = _useState6[0],
      setInfoMessage = _useState6[1];

  var handleRegisterProfile = function handleRegisterProfile() {
    setLoading(true);
    (0,_services_AuthenticationService__WEBPACK_IMPORTED_MODULE_9__/* .registerProfile */ .C$)(registerInfo).then( /*#__PURE__*/function () {
      var _ref2 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(response) {
        return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (response.data) {
                  setUser(response.data.user);
                  onNextButtonClick();
                } else if (response.error) {
                  setRegisterProfileError(true);

                  if (typeof response.error === "string") {
                    setErrorMessage(response.error);
                  } else {
                    setErrorMessage((0,src_utils_string_utils__WEBPACK_IMPORTED_MODULE_13__/* .extractErrorMessageFromProblemDetails */ .RR)(response.error));
                  }
                } else {
                  setRegisterProfileError(true);
                  setErrorMessage("Unable to complete registration. Please contact support at audience@thatstheticket.com.au");
                }

                setLoading(false);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
  };

  var handleResendVerificationcode = function handleResendVerificationcode() {
    var confirmPhoneNumberData = {
      email: registerInfo.user.email,
      phoneNumber: registerInfo.user.phoneNumber
    };
    (0,_services_AuthenticationService__WEBPACK_IMPORTED_MODULE_9__/* .sendConfirmPhoneNumberSMS */ .q0)(confirmPhoneNumberData).then(function (res) {
      if (res.status == 400) {
        var _res$errors, _res$errors2;

        setRegisterProfileError(true);
        setErrorMessage((_res$errors = res.errors) !== null && _res$errors !== void 0 && _res$errors.message ? (_res$errors2 = res.errors) === null || _res$errors2 === void 0 ? void 0 : _res$errors2.message : "An error occured");
      } else if (res.status == 200) {
        setShowInfoMessage(true);
        setInfoMessage("We have resent your phone verification code. If you don't receive it shortly, ensure your phone number is correct, and try again.");
      }
    });
  };

  var isContinueButtonDisabled = registerInfo.phoneNumberVerificationCode.length < inputLength || verificationCodeHasError ? true : false;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(_PhoneNumberVerification_styles__WEBPACK_IMPORTED_MODULE_4__/* .PhoneNumberVerificationContainer */ .Vr, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(___WEBPACK_IMPORTED_MODULE_5__/* .TitleSubtitle */ .V9, {
      size: "sm",
      title: "Verify Your Number",
      subTitle: "Enter the code we just sent you via text below"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_PhoneNumberVerification_styles__WEBPACK_IMPORTED_MODULE_4__/* .FieldsContainer */ .LA, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_VerificationCodeInput_VerificationCodeInput__WEBPACK_IMPORTED_MODULE_6__/* .VerificationCodeInput */ .a, {
        errorFromOutside: true,
        inputLength: 6,
        getConcatenatedValues: function getConcatenatedValues(value) {
          setRegisterInfo(function (prevRegisterInfo) {
            return _objectSpread(_objectSpread({}, prevRegisterInfo), {}, {
              phoneNumberVerificationCode: value
            });
          });
          setShowInfoMessage(false);
        },
        hasError: function hasError(value) {
          setVerificationCodeHasError(value);
        }
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(_PhoneNumberVerification_styles__WEBPACK_IMPORTED_MODULE_4__/* .ResendCode */ .df, {
      children: ["Didn\u2019t get it? ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_PhoneNumberVerification_styles__WEBPACK_IMPORTED_MODULE_4__/* .StyledBlueSpan */ .gj, {
        onClick: handleResendVerificationcode,
        children: "Resend code"
      })]
    }), registerProfileError && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(___WEBPACK_IMPORTED_MODULE_5__/* .InfoMessage */ .$J, {
      "data-cy": "register-error",
      variant: "error",
      hasBackground: true,
      message: errorMessage
    }), showInfoMessage && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(___WEBPACK_IMPORTED_MODULE_5__/* .InfoMessage */ .$J, {
      "data-cy": "register-warning",
      variant: "info",
      hasBackground: true,
      message: infoMessage
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(_pages_Register_Register_styles__WEBPACK_IMPORTED_MODULE_7__/* .CTABackAndForthContainer */ .uF, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(___WEBPACK_IMPORTED_MODULE_5__/* .Button */ .zx, {
        size: "md",
        variant: "tertiary",
        onClick: function onClick() {
          return onPrevButtonClick();
        },
        "data-cy": "button-booking-next",
        sx: {
          padding: 0
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(_pages_Register_Register_styles__WEBPACK_IMPORTED_MODULE_7__/* .ButtonContainer */ .qO, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_pages_Register_Register_styles__WEBPACK_IMPORTED_MODULE_7__/* .ButtonIcon */ .Ei, {
            icon: "ArrowLeft"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_pages_Register_Register_styles__WEBPACK_IMPORTED_MODULE_7__/* .ButtonLabel */ .aN, {
            children: "Back"
          })]
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(___WEBPACK_IMPORTED_MODULE_5__/* .Button */ .zx, {
        "data-cy": "register-phone-number-verification-code-submit",
        onClick: handleRegisterProfile,
        disabled: isContinueButtonDisabled,
        loading: loading,
        children: " Verify Number "
      })]
    })]
  });
};

PhoneNumberVerification.displayName = "PhoneNumberVerification";
var ComponentWithRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.withRouter)(PhoneNumberVerification);


/***/ }),

/***/ 1837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Kz": function() { return /* reexport */ ComponentWithRouter; },
  "My": function() { return /* reexport */ EmailVerification_ComponentWithRouter; },
  "ro": function() { return /* reexport */ Password/* Password */.r; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/Register/BasicInfo/BasicInfo.styles.ts
var BasicInfo_styles = __webpack_require__(71743);
// EXTERNAL MODULE: ./src/components/index.ts + 107 modules
var components = __webpack_require__(33609);
// EXTERNAL MODULE: ./src/pages/Register/Register.styles.ts
var Register_styles = __webpack_require__(85614);
// EXTERNAL MODULE: ./src/utils/regex.tsx
var regex = __webpack_require__(37001);
// EXTERNAL MODULE: ./src/services/AuthenticationService.tsx
var AuthenticationService = __webpack_require__(28148);
// EXTERNAL MODULE: ./src/contexts/RegisterContext.tsx
var RegisterContext = __webpack_require__(72078);
// EXTERNAL MODULE: ./src/models/FieldLengths.ts
var FieldLengths = __webpack_require__(50264);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Register/BasicInfo/BasicInfo.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var Logo = function Logo(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M447.23 284.71c21.71 6.21 37.49 23.62 42.22 45.57q1.31 6.08 1.31 16.56-.02 44.58-.01 89.2c0 5.92-2.19 8.19-7.94 8.2l-12.03.02c-5.81 0-8.79-1.75-8.78-7.74q.02-45.08-.01-90.17-.01-8.28-1.38-12.52c-9.53-29.38-55.33-30.85-64.84-1.04q-1.31 4.12-1.3 11.55.1 45.61.02 91.2c-.01 5.5-1.65 8.65-7.4 8.69q-7.68.05-15.34 0c-4.46-.03-6-3.77-6-7.89V227.7c0-4.32 1.67-7.78 6.25-7.88q11.53-.26 16.01.01c5.25.31 6.47 4 6.48 8.83q.04 26.72 0 53.42c-.01 7.74 5.65 9.78 12.15 6.73 14.02-6.58 25.59-8.4 40.59-4.1zm378.75 18.13-5.05-75.62a.44.44 0 0 1 .44-.47h26.9a.44.44 0 0 1 .44.47l-5.35 75.62a.44.44 0 0 1-.44.41h-16.5a.44.44 0 0 1-.44-.41zM273.99 415.2c13.69 8.64 32.56-.23 33.75-17.08.39-5.58 1.95-8.04 7.62-8.09q6.4-.07 12.81-.02c10.81.08 8.92 9.29 7.07 17.21q-4.28 18.35-18.17 29.29c-20.83 16.4-50.34 13.9-68.44-5.24q-13.9-14.69-13.89-36.27.02-38.51.01-76.5a2.74 2.74 0 0 0-2.74-2.74q-15.49-.02-30.98-.01c-4.27.01-7.23-1.91-7.26-6.33q-.04-7.33-.02-14.66c.02-5.17 2.16-7.72 7.28-7.74q15.94-.04 31.24-.01a2.48 2.48 0 0 0 2.48-2.48q.01-24.15 0-49.03c0-5.33 3.48-7 8.46-7q6.23-.01 12.44.01c4.65.02 8.1 1.82 8.1 6.74v49.26a2.49 2.49 0 0 0 2.49 2.49h51.26c4.38 0 6.22 3.48 6.23 7.64q.02 6.76.03 13.5c.01 4.47-1.69 7.61-6.42 7.6q-25.53 0-50.77.02a2.82 2.81 0 0 0-2.82 2.81v76.18c.01 8.87 2.83 15.78 10.24 20.45zm457.47-129.04.55.46q.47.38 1.07.38 24.56 0 49.1.01c6.13 0 8.73 1.87 8.79 8 .08 6.91 1.37 16.82-2.69 19.61q-1.66 1.13-5.31 1.13H733.7a2.96 2.96 0 0 0-2.96 2.96q.03 37.06-.01 74.74 0 6.72 1.31 10.42c5.85 16.45 26.76 19.89 37.83 6.31q4.44-5.45 4.93-14.17c.29-5.02 4.58-5.98 9.07-6q6.69-.03 13.38 0c4.34.02 6.27 3.52 6.27 7.64-.01 15.79-8.46 30.97-20.77 39.9-29.5 21.43-70.79 6.01-79.39-29.08q-1.35-5.52-1.36-15.54v-74.02a3.15 3.15 0 0 0-3.14-3.15q-15.87-.04-32.11.01c-4.33.01-5.94-3.6-5.98-7.62q-.06-6.55-.01-13.11c.04-4.4 1.79-8.06 6.49-8.05q16.26.02 31.88 0a2.85 2.85 0 0 0 2.84-2.85q.03-24.3.04-48.24c0-4.81 2.13-7.38 6.92-7.39q7-.02 13.99-.01c5.43 0 7.81 2.32 7.82 7.59q.02 24.34 0 48.55a1.97 1.96 19.7 0 0 .72 1.52zm-118.21 62.16c5.09.04 3.5-8.85 3.52-12.07q.08-20.15-18.83-25.14c-9.67-2.56-26.42-1.63-34.46 5.05q-5.26 4.38-5.49 12.59-.12 4.13-5 4.3-6.65.22-13.3.19c-5.1-.03-9.47.41-9.88-5.48q-.63-9.15 4.3-18.9c7.77-15.36 27.35-24.06 44.01-26.03 27.61-3.28 59.28 6.97 66.02 37.51q1.29 5.86 1.32 19.92.09 47.8.02 95.61c-.01 5.39-1.83 8.29-7.35 8.36q-7.39.1-10.38.01c-6.37-.2-5.89-12.33-13.27-8.07-8.8 5.08-15.36 9.39-26.48 10.67-15.23 1.75-32.09-.94-44.71-9.4-26.55-17.78-28.2-60.42-2.06-79.28q8.72-6.29 19.61-8.58 5.86-1.23 19.91-1.3 16.25-.09 32.5.04zm-19.37 71.34q19.83-3.46 24.27-21.47c1.49-6.07 1.23-14.18 1.06-20.9a2.85 2.84 89.3 0 0-2.84-2.78q-20.92-.04-41.97.02c-10.5.02-19.79 4.17-22.33 15.24-2.82 12.3 1.81 24.93 14.44 29.17 8.27 2.78 19.14 2.15 27.37.72zm340.75-136.78c24.27 2.93 46.98 19.2 47.65 45.53.14 5.39-2.03 8.03-7.38 8.07q-6.29.05-12.58.02c-4.38-.03-8.5-1.18-8.78-6q-.37-6.63-2.79-10.34-4.46-6.82-12.39-8.99c-12.68-3.46-33.42-2.63-39.44 12.07q-3.6 8.77 4.14 15.18c5.09 4.2 13.7 5.93 20.97 7.15 30.66 5.11 65.02 12.39 64.33 52.05-.91 52.21-72.46 61.2-105.63 37.21-13.4-9.69-20.66-27-19.73-43.09.25-4.37 3.77-5.72 7.85-5.73q6.47-.03 12.95.01c4.21.02 8 1.7 7.99 6.23-.02 25.31 22.62 28.75 42.21 27.28 13.97-1.05 26.73-8.39 25.59-24.29-2.21-30.83-83.92-9.29-90.88-60.74-5.08-37.49 35.16-55.34 65.92-51.62zM460.57 605.39c-9.44-29.3-55.17-30.67-64.82-.95q-1.28 3.95-1.27 10.75.08 47.29.01 94.56c-.01 4.36-3.82 6-7.88 6q-6.58-.01-13.13.01c-5.11.02-7.73-1.85-7.73-7.02q0-104.85.01-209.71c0-3.78 1.73-7.47 5.73-7.5q7.45-.06 14.89-.02c5.44.04 8.09 2.19 8.1 7.61q.06 27.61.01 55.22c-.01 6.44 5.51 9.26 11.28 6.59 9.63-4.45 17.25-7.42 27.48-6.86 27.38 1.48 50.08 20.27 56.07 47.07q1.4 6.25 1.41 18.33.05 44.5 0 89c0 4.21-1.92 7.26-6.31 7.27l-14.71.02c-4.98.01-7.7-1.98-7.7-7.01q-.02-44.49-.01-88.98.01-9.91-1.43-14.38z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
      x: "-16",
      y: "-16.13",
      transform: "rotate(.115 -290264.664 564080.533)",
      width: "32",
      height: "32.26",
      rx: "5.22"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M1266.16 608.54q.49.97 1.4.71.36-.11.82-.52 26.39-24.28 52.76-48.59c2.35-2.17 4.63-2.86 8.03-2.87q8.92-.03 17.84-.03c4.08.01 6.69 4.69 5.47 8.37q-.51 1.55-2.99 3.87-32.02 30.08-63.42 59.72-3.7 3.49-.03 7.02 35.98 34.51 72.31 69.43c2.89 2.78 1.09 7.58-2.01 9.27q-1.55.84-5.32.84-8.98 0-17.97-.03c-3.92-.02-6.55-1.26-9.21-3.82q-26.86-25.89-53.65-51.86-1.22-1.19-2.36-1.83a1.23 1.23 0 0 0-1.83 1.07q-.01 24.84 0 49.96c0 4.53-3.04 6.45-7.42 6.48q-6.99.04-13.98.02c-4.53-.01-7.34-2.04-7.34-6.65q-.01-104.57-.01-209.14c0-5.87 1.8-8.41 7.7-8.44q7.27-.03 14.56-.04c4.85 0 6.48 3.89 6.48 8.36q.02 53.93.01 108a1.62 1.59-58.5 0 0 .16.7zM234.72 556.31q.1-24.09.01-48.81-.02-7.1 7.26-7.3 6.45-.17 12.89-.18c6.23 0 8.84 2.1 8.85 8.29q.04 23.85.01 47.66a2.79 2.79 0 0 0 2.79 2.79q24.8-.02 49.86.01c4.51 0 7.36 2.01 7.36 6.62q-.01 6.87.01 13.71c.02 5.64-1.65 8.38-7.42 8.39q-25.16.03-50.1.01a2.48 2.48 0 0 0-2.49 2.48q0 37.04-.01 74.7 0 7.52 1.23 10.99c5.71 16.07 26.55 19.59 37.46 6.77q4.97-5.84 5.35-14.69c.2-4.65 3.87-5.99 8.16-5.99l14.31-.02c5.17-.01 6.43 4.38 6.23 8.9-1.06 23.13-17.98 42.57-40.23 47.35-32.47 6.96-61.51-18.38-61.5-50.99q.01-38.87 0-77.01a2.48 2.48 0 0 0-2.48-2.48q-16.02-.03-32.52 0c-4.68.01-6-4.01-6.01-8.22q-.01-6.54.03-13.08c.04-5.11 2.23-7.47 7.23-7.46q15.75.02 31.28-.01a2.44 2.44 0 0 0 2.44-2.43zm658.32 129.73q-6.53 16.64-20.92 25.46c-29.42 18.02-68.14 2-75.99-31.29q-1.39-5.91-1.39-17.53.02-36.2.01-72.23a2.95 2.95 0 0 0-2.95-2.95q-14.66-.01-29.91 0c-5.54 0-8.37-1.68-8.38-7.39q-.02-6.65 0-13.28c.01-5.42 1.84-8.07 7.33-8.07q15.79-.01 30.96-.01a2.96 2.95-89.9 0 0 2.95-2.95q.01-23.74-.01-47.67c0-5.66 2.12-8.03 7.66-8.1q6.11-.07 12.23-.02c6.35.06 8.87 1.97 8.87 8.31v47.73a2.7 2.7 0 0 0 2.7 2.7q24.5.01 49.41 0c5.53 0 8.05 2.18 8.11 7.62q.08 6.34.01 12.68c-.05 5.64-1.91 8.44-7.66 8.44q-25.03.03-49.87.01a2.69 2.69 0 0 0-2.7 2.69v73.52q0 8.52 1.44 12.37c4.01 10.7 15.87 16.66 26.95 13.18q12.06-3.78 15.27-16.79c.98-3.95-.56-7.44 3.66-9.87 3.08-1.78 13.09-.86 16.96-.85q3.76 0 5.32.76c6.16 2.97 2.06 18.12-.06 23.53zm704.77-96.02a1.74 1.68 53.5 0 0-.06.45q-.01 36.62.01 73.3 0 8.43 1.45 12.26c4.13 10.9 16.3 16.86 27.54 13.07q11.22-3.79 14.67-16.22c1.07-3.87-.64-8.2 4.04-10.48q1.26-.61 3.7-.63 6.66-.05 13.33-.02c9.38.05 8.75 6.71 7.67 13.8-2.04 13.36-9.14 25.19-19.68 33.16-29.44 22.24-71.56 6.77-80.11-28.84q-1.36-5.71-1.37-16.35-.01-36.63 0-73.13a2.88 2.87-90 0 0-2.87-2.88q-14.74-.03-29.99 0c-5.43.01-8.32-1.85-8.37-7.4q-.06-7.68 0-15.36c.04-4.57 4.02-5.99 8.19-5.99q15.35-.01 30.16-.01a2.87 2.87 0 0 0 2.87-2.87q.03-23.29 0-47.12c-.01-5.87 1.75-8.68 7.74-8.73q7.26-.07 14.52-.02c5.08.04 6.49 4.01 6.5 8.62q.01 23.57 0 47.21a2.91 2.91 0 0 0 2.91 2.92q24.53-.02 49.65.01c4.89 0 7.57 2.04 7.65 6.94q.11 7.13 0 14.25c-.07 4.64-2.18 7.51-6.9 7.52q-24.82.05-49.64.01c-1.89 0-3.13.58-3.61 2.53zm-950.72 93.05c-6.26 16.07-19.81 27.49-36.13 32.53-36.66 11.34-75.66-5.49-85.56-44.34q-1.71-6.71-2.27-17.64-.94-18.36.15-37.62c2.6-45.81 42.98-70.96 86.18-59.23 23.5 6.37 38.1 24.16 41.65 47.84 1.46 9.77.95 22.47.87 33.49-.03 4.61-1.84 7.64-6.66 7.64q-45.03.02-90.07.01-3.27 0-3.33 3.24c-.37 20.37 8.11 37.85 30.07 40.9q13.47 1.87 24.44-3.48 10.78-5.27 15.18-17.55c1-2.8 3.96-3.81 6.96-3.83q7.44-.05 14.89-.03c3.75.01 6.95.98 6.78 5.25q-.22 5.31-3.15 12.82zm-91.4-62.69 65.76-.22a3.15 3.15 0 0 0 3.13-3.17v-1.02a34.57 33.33-.2 0 0-34.69-33.2l-2.92.01a34.57 33.33-.2 0 0-34.45 33.45v1.02a3.15 3.15 0 0 0 3.17 3.13zm556.25-62.46c37.25-12.69 84.39 5.95 84.89 50.31.06 5.34-3.67 6.3-8.35 6.28q-7.38-.02-14.71-.13c-4.83-.07-5.52-2.66-5.86-7.08-1.36-17.38-18.68-24.96-33.98-24.54-13.55.37-25.39 7.43-30.55 20.17q-2.35 5.8-2.96 17-.88 15.93-.07 31.87.66 12.85 3.25 19.02c6.21 14.81 22.04 21.12 37.78 19.15 13.26-1.66 25.63-10.51 26.32-25 .19-3.81 1.32-6.19 5.31-6.39q4.66-.22 15.16-.07c6.07.09 8.81 2.14 8.58 8.29-1.46 38.07-38.71 56.69-72.75 51.34-25.65-4.03-43.94-21.73-50.1-46.9q-1.62-6.6-2.27-18.12-1.28-22.5.64-42.37c2.24-23.13 17.33-45.22 39.67-52.83zm333.93 160.91c-37.6 2.4-67.62-22.04-70.12-60.09q-1.56-23.64-.17-44.49c1.98-29.65 22.3-53.91 51.92-59.13 40.03-7.05 75.8 15.67 76.63 58.63q.4 20.76.05 26.5c-.26 4.23-4.09 5.5-8 5.5H1407c-2.13 0-2.98 1.8-2.98 3.79q.01 9.43 2.03 15.98 7.34 23.88 32.71 24.9c13.32.54 27.61-5.04 33.56-17.68 2.29-4.86 2.24-7.7 8.87-7.73q7.42-.02 14.83-.01c4.83 0 7.03 2.09 6.24 6.89-4.72 28.63-28.73 45.18-56.39 46.94zm-38-98.46 65.86-.23a3.09 3.09 0 0 0 3.07-3.1v-1.13a34.56 33.26-.2 0 0-34.68-33.13l-2.92.01a34.56 33.26-.2 0 0-34.44 33.38v1.13a3.09 3.09 0 0 0 3.11 3.07zm-408.78 66.78c.71 1.2 1.87 1.6 3.29 1.6h38.05c5.45 0 7.99 1.87 8.04 7.33q.06 5.88.02 11.77c-.03 4.47-1.58 7.89-6.43 7.89q-57.9.02-115.79.01c-5.21 0-7.93-1.73-7.99-7.06q-.07-6.96-.03-13.95c.03-4.24 3.6-5.96 7.6-5.97q20.36-.04 40.61-.01a2.79 2.79 0 0 0 2.79-2.79v-98.95a2.78 2.77.1 0 0-2.77-2.77q-18.46-.01-37.01 0c-4.92.01-7.88-1.61-7.94-6.75q-.08-6.48-.01-12.96c.04-4.22 1.89-7.28 6.32-7.28q31.54-.02 63.07-.01c5.52.01 7.83 2.22 7.83 7.6q.02 60.56.01 121.05a2.48 2.46 30 0 0 .34 1.25zm63.17 218.78c-55.41-1.12-97.06-31.32-125.13-77.23q-3.84-6.27-4.39-9.94c-2-13.41 14.1-22.54 24.9-14.76q2.01 1.45 5.5 6.2c23.85 32.44 53.2 54.88 94.99 56.85q6.81.33 13.62.15c42.24-1.12 73.53-22.77 97.48-55.96q4.18-5.79 6.32-7.32c10.73-7.68 26.53 1.24 24.84 14.64q-.47 3.7-3.93 9.4c-13.22 21.74-30.4 41.8-51.76 55.69-24.98 16.24-52.67 22.89-82.44 22.28z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      style: {
        fontWeight: "700",
        fontSize: "122.5px",
        fontFamily: "Monospace",
        InkscapeFontSpecification: "'Monospace Bold'",
        fill: "#fff",
        strokeWidth: "13.125"
      },
      d: "M1537.917 842.137q0-10.467 3.47-21.174 2.571-7.895 7.954-17.585 3.888-6.939 5.743-8.494 1.854-1.615 4.127-1.615 2.632 0 4.426 1.794 1.794 1.795 1.794 4.307 0 1.735-1.435 4.127-6.46 10.587-9.45 19.859-2.932 9.27-2.932 18.781 0 9.57 2.931 18.842 2.991 9.271 9.451 19.858 1.435 2.333 1.435 4.127 0 2.513-1.794 4.307-1.794 1.795-4.426 1.795-2.213 0-3.888-1.436-2.393-2.094-6.34-9.39-5.683-10.588-7.776-17.467-3.29-10.527-3.29-20.636zm62.446-47.791v27.514q4.486-2.93 9.092-4.366 4.665-1.496 9.39-1.496 12.741 0 21.594 8.793 8.852 8.793 8.852 21.234 0 11.903-8.434 19.918-8.433 7.956-22.25 7.956-4.905 0-9.451-1.256t-8.793-3.709v2.99h-14.355q-4.427 0-6.34-1.674-1.855-1.734-1.855-4.486 0-2.692 1.914-4.366 1.914-1.735 6.28-1.735h2.094v-53.055h-2.093q-4.427 0-6.34-1.675-1.855-1.735-1.855-4.486 0-2.692 1.854-4.367 1.914-1.734 6.34-1.734zm36.666 52.038q0-7.596-5.323-12.86-5.324-5.264-13.04-5.264-7.656 0-12.98 5.264-5.323 5.264-5.323 12.68 0 6.76 4.785 11.126 4.785 4.307 13.518 4.307t13.518-4.307q4.845-4.366 4.845-10.946zm83.083 4.606h-50.304q1.914 4.785 6.759 7.716 4.905 2.93 13.219 2.93 6.819 0 18.123-2.93 4.666-1.196 6.46-1.196 2.453 0 4.128 1.734 1.674 1.735 1.674 4.367 0 2.392-1.794 4.067-2.393 2.213-11.664 4.247-9.271 1.974-17.825 1.974-14.714 0-23.566-8.314-8.793-8.315-8.793-20.457 0-12.92 9.51-20.995 9.57-8.135 22.012-8.135 7.477 0 13.698 2.632 6.28 2.632 9.33 5.683 4.307 4.426 7.119 10.946 1.914 4.546 1.914 10.527zm-13.578-12.262q-2.812-5.264-7.357-7.836-4.546-2.632-10.827-2.632-6.22 0-10.766 2.632-4.546 2.572-7.417 7.836zm53.294-8.853v24.584q0 3.948 1.615 5.204 2.513 1.974 8.973 1.974 9.39 0 17.346-4.008 3.05-1.555 4.785-1.555 2.393 0 4.127 1.795 1.795 1.794 1.795 4.366 0 2.393-1.914 4.127-2.931 2.811-11.604 5.204-8.614 2.333-14.535 2.333-11.425 0-17.167-4.905-5.683-4.965-5.683-12.142v-26.977h-4.426q-4.426 0-6.34-1.674-1.854-1.735-1.854-4.487 0-2.691 1.854-4.366 1.914-1.735 6.34-1.735h4.426v-11.065q0-4.427 1.675-6.28 1.735-1.915 4.486-1.915 2.692 0 4.367 1.914 1.734 1.854 1.734 6.28v11.066h22.67q4.426 0 6.28 1.735 1.915 1.675 1.915 4.426 0 2.692-1.914 4.427-1.855 1.674-6.28 1.674zm87.569 42.05v-2.871q-4.606 2.452-10.169 3.649-5.562 1.256-10.108 1.256-9.87 0-16.03-5.204-6.161-5.264-6.161-11.604 0-7.716 7.835-14.296 7.896-6.64 21.773-6.64 5.562 0 12.86 1.197v-2.93q0-2.752-2.393-4.487-2.332-1.735-8.972-1.735-5.443 0-14.116 2.154-3.23.777-5.024.777-2.453 0-4.187-1.734-1.675-1.795-1.675-4.546 0-1.555.598-2.692.598-1.136 1.675-1.794 1.076-.718 4.486-1.675 4.546-1.256 9.27-1.974 4.726-.778 8.554-.778 11.425 0 17.706 4.965 6.34 4.905 6.34 13.458v25.242h2.093q4.427 0 6.28 1.735 1.915 1.674 1.915 4.426 0 2.692-1.914 4.426-1.854 1.675-6.28 1.675zm0-21.952q-7.357-1.436-13.578-1.436-7.477 0-12.86 3.65-3.35 2.332-3.35 4.725 0 1.734 1.615 2.81 2.991 1.975 8.195 1.975 4.426 0 9.989-1.735 5.622-1.735 9.989-4.725zm67.71-7.836q0 10.468-3.47 21.234-2.571 7.896-7.955 17.526-3.888 6.939-5.742 8.554-1.854 1.615-4.127 1.615-2.632 0-4.426-1.795-1.795-1.794-1.795-4.307 0-1.794 1.436-4.127 6.46-10.587 9.39-19.858 2.991-9.271 2.991-18.842 0-9.51-2.99-18.781-2.931-9.272-9.391-19.859-1.436-2.392-1.436-4.127 0-2.512 1.795-4.307 1.794-1.794 4.426-1.794 2.213 0 3.888 1.435 2.392 2.034 6.34 9.391 5.682 10.588 7.776 17.406 3.29 10.588 3.29 20.636z"
    })]
  }));
};

Logo.defaultProps = {
  width: "150",
  height: "80",
  viewBox: "0 0 1920 1050",
  fill: "#FCFCFC",
  xmlns: "http://www.w3.org/2000/svg"
};











var BasicInfo = function BasicInfo(_ref) {
  var onNextButtonClick = _ref.onNextButtonClick;

  var _useRegisterContext = (0,RegisterContext/* useRegisterContext */.$)(),
      setRegisterInfo = _useRegisterContext.setRegisterInfo;

  var _useState = (0,react.useState)(""),
      email = _useState[0],
      setEmail = _useState[1];

  var _useState2 = (0,react.useState)(""),
      firstName = _useState2[0],
      setFirstName = _useState2[1];

  var _useState3 = (0,react.useState)(""),
      lastName = _useState3[0],
      setLastName = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      isTTTAgreed = _useState4[0],
      setIsTTTAgreed = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      emailError = _useState5[0],
      setEmailError = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      registerError = _useState6[0],
      setRegisterError = _useState6[1];

  var _useState7 = (0,react.useState)(""),
      errorMessage = _useState7[0],
      setErrorMessage = _useState7[1];

  var _useState8 = (0,react.useState)(false),
      loading = _useState8[0],
      setLoading = _useState8[1];

  var isSubmitButtonDisabled = function isSubmitButtonDisabled() {
    return !isTTTAgreed || !email || !firstName || !lastName;
  };

  var handleEmailChange = function handleEmailChange(event) {
    setEmail(event.target.value);
    setEmailError(false);
    setRegisterError(false);
  };

  var handleRegister = function handleRegister() {
    if (!(0,regex/* emailValidation */.D6)(email)) {
      setEmailError(true);
      setRegisterError(true);
      setErrorMessage("Oops! Your email appears to be in the wrong format.");
      return;
    }

    setEmailError(false);
    setRegisterError(false);
    setLoading(true);
    var registerData = {
      user: {
        email: email,
        firstName: firstName,
        lastName: lastName
      }
    };
    (0,AuthenticationService/* registerBasicInfo */.aH)(registerData).then(function (res) {
      if (res.status == 400) {
        var _res$errors;

        setRegisterError(true);
        setErrorMessage((_res$errors = res.errors) === null || _res$errors === void 0 ? void 0 : _res$errors.message[0]);
      } else if (res.status == 200) {
        onNextButtonClick();
        setRegisterInfo(function (prevRegisterInfo) {
          return _objectSpread(_objectSpread({}, prevRegisterInfo), {}, {
            user: _objectSpread(_objectSpread({}, prevRegisterInfo.user), registerData.user)
          });
        });
      }

      setLoading(false);
    });
  };

  var registerNameMessage = "This is the name that will appear on your ticket. Please enter your name as it appears on your ID. Some shows may require you to present identification to enter.";
  var registerEmailMessage = "This is the email address your tickets will be sent to. Please use a personal email address you have access to at all times. You never know when an important update or ticket offer may be sent!";
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(BasicInfo_styles/* BasicInfoContainer */.j3, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BasicInfo_styles/* ImageContainer */.mo, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Logo, {})
    }), !email && /*#__PURE__*/(0,jsx_runtime.jsxs)(BasicInfo_styles/* Title */.Dx, {
      children: ["My name is...", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(BasicInfo_styles/* FieldsContainer */.LA, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(BasicInfo_styles/* NameInputContainer */.XN, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* TextField */.nv, {
          "data-cy": "register-first-name",
          autoFocus: true,
          value: firstName,
          onChange: function onChange(event) {
            return setFirstName(event.target.value);
          },
          placeholder: "First Name",
          inputProps: {
            maxLength: FieldLengths/* FieldLengths.user.firstName */.t.user.firstName
          },
          size: "lg"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* TextField */.nv, {
          "data-cy": "register-last-name",
          value: lastName,
          onChange: function onChange(event) {
            return setLastName(event.target.value);
          },
          placeholder: "Last Name",
          inputProps: {
            maxLength: FieldLengths/* FieldLengths.user.lastName */.t.user.lastName
          },
          size: "lg"
        })]
      }), firstName && lastName && !email && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* InfoMessage */.$J, {
        "data-cy": "name-register-info",
        variant: "info",
        hasBackground: true,
        message: registerNameMessage
      }), email && !isTTTAgreed && /*#__PURE__*/(0,jsx_runtime.jsxs)(BasicInfo_styles/* Title */.Dx, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Enter Your Email Address", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* TextField */.nv, {
        "data-cy": "register-email",
        fullWidth: true,
        error: emailError,
        value: email,
        onChange: handleEmailChange,
        placeholder: "Email",
        size: "lg"
      }), registerError && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* InfoMessage */.$J, {
        "data-cy": "register-error",
        variant: "error",
        hasBackground: true,
        message: errorMessage
      }), email && !isTTTAgreed && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* InfoMessage */.$J, {
        "data-cy": "email-register-info",
        variant: "info",
        hasBackground: true,
        message: registerEmailMessage
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Checkbox */.XZ, {
        "data-cy": "register-tc-checkbox",
        checked: isTTTAgreed,
        onChange: setIsTTTAgreed,
        label: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: ["I agree to TTT\u2019s ", " ", /*#__PURE__*/(0,jsx_runtime.jsx)(BasicInfo_styles/* StyledLink */.Fg, {
            target: "_blank",
            href: "https://www.thatstheticket.com.au/_files/ugd/e9ec41_6389a51e79cb4768a2027f293c0b6dd0.pdf",
            children: "Privacy Policy and Collection Statement."
          }), "\xA0", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "*Fear not! We don't sell or share your contact details with anyone."]
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Register_styles/* CTAForthContainer */.Uh, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(BasicInfo_styles/* CustomSubmitButton */.Yf, {
        "data-cy": "register-basic-info-submit",
        onClick: handleRegister,
        disabled: isSubmitButtonDisabled(),
        disabledStateStyling: "lowOpacity",
        full: true,
        loading: loading,
        children: "Join Us"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(BasicInfo_styles/* AlreadyMemberButton */.Oc, {
      children: ["Already a Member? ", /*#__PURE__*/(0,jsx_runtime.jsx)(BasicInfo_styles/* StyledLink */.Fg, {
        href: "/login",
        children: "Login"
      })]
    })]
  });
};

BasicInfo.displayName = "BasicInfo";
var ComponentWithRouter = (0,router.withRouter)(BasicInfo);

// EXTERNAL MODULE: ./src/components/Register/Password/Password.tsx + 1 modules
var Password = __webpack_require__(91610);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
;// CONCATENATED MODULE: ./src/components/Register/EmailVerification/EmailVerification.styles.ts


var EmailVerificationContainer = (0,styled/* default */.ZP)("div")(function (_ref) {
  var theme = _ref.theme;
  return {
    display: "flex",
    width: theme.space._1300,
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.space._500,
    alignSelf: "stretch",
    "@media (max-width: 600px)": {
      width: "100%"
    }
  };
});
var FieldsContainer = (0,styled/* default */.ZP)("div")(function (_ref2) {
  var theme = _ref2.theme;
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.space._400,
    alignSelf: "stretch"
  };
});
var ResendCode = (0,styled/* default */.ZP)(Typography/* default */.Z)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    color: theme.colors["neutral.500"],
    textAlign: "center",
    fontSize: theme.fontSizes.sm,
    fontFamily: theme.fonts["default"],
    fontWeight: theme.fontWeights.regular,
    lineHeight: theme.lineHeights.base
  };
});
// EXTERNAL MODULE: ./src/components/VerificationCodeInput/VerificationCodeInput.tsx + 1 modules
var VerificationCodeInput = __webpack_require__(2595);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(69417);
// EXTERNAL MODULE: ./src/utils/string-utils.tsx
var string_utils = __webpack_require__(46955);
;// CONCATENATED MODULE: ./src/components/Register/EmailVerification/EmailVerification.tsx













var EmailVerification = function EmailVerification(_ref) {
  var onNextButtonClick = _ref.onNextButtonClick,
      onPrevButtonClick = _ref.onPrevButtonClick;
  var inputLength = 6;

  var _useState = (0,react.useState)(''),
      verificationCode = _useState[0],
      setVerificationCode = _useState[1];

  var _useState2 = (0,react.useState)(false),
      verificationCodeHasError = _useState2[0],
      setVerificationCodeHasError = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      loading = _useState3[0],
      setLoading = _useState3[1];

  var _useState4 = (0,react.useState)(""),
      errorMessage = _useState4[0],
      setErrorMessage = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      showError = _useState5[0],
      setShowError = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      showInfoMessage = _useState6[0],
      setShowInfoMessage = _useState6[1];

  var _useState7 = (0,react.useState)(""),
      infoMessage = _useState7[0],
      setInfoMessage = _useState7[1];

  var _useRegisterContext = (0,RegisterContext/* useRegisterContext */.$)(),
      registerInfo = _useRegisterContext.registerInfo;

  var isContinueButtonDisabled = verificationCode.length < inputLength || verificationCodeHasError;

  var handleVerifyEmail = function handleVerifyEmail() {
    setLoading(true);
    setShowError(false);
    (0,AuthenticationService/* confirmEmailAddress */.rx)({
      token: verificationCode,
      user: {
        email: registerInfo.user.email
      }
    }).then(function (response) {
      if (response.data) {
        onNextButtonClick();
      } else if (response.error) {
        setShowError(true);

        if (typeof response.error === "string") {
          setErrorMessage(response.error);
        } else {
          setErrorMessage((0,string_utils/* extractErrorMessageFromProblemDetails */.RR)(response.error));
        }
      }

      setLoading(false);
    });
  };

  var handleResendCode = function handleResendCode() {
    setShowInfoMessage(false);
    setShowError(false);
    (0,AuthenticationService/* resendConfirmationEmail */.Ot)(registerInfo.user.email).then(function (res) {
      if (res.status >= 400) {
        var _res$errors, _res$errors2;

        setShowError(true);
        setErrorMessage((_res$errors = res.errors) !== null && _res$errors !== void 0 && _res$errors.message ? (_res$errors2 = res.errors) === null || _res$errors2 === void 0 ? void 0 : _res$errors2.message : "An error occurred");
      } else {
        setShowInfoMessage(true);
        setInfoMessage("We have resent your verification code. If you don't receive it shortly, check your spam folder and try again.");
      }
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(EmailVerificationContainer, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* TitleSubtitle */.V9, {
      "data-cy": "register-verify-email-title",
      size: "sm",
      title: "Verify Your Email",
      subTitle: "We just emailed you a code at ".concat(registerInfo.user.email, ", enter it below to verify your email address")
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FieldsContainer, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(VerificationCodeInput/* VerificationCodeInput */.a, {
        errorFromOutside: true,
        inputLength: 6,
        getConcatenatedValues: function getConcatenatedValues(value) {
          setVerificationCode(value);
          setShowInfoMessage(false);
        },
        hasError: function hasError(value) {
          setVerificationCodeHasError(value);
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ResendCode, {
      children: ["Didn't get it? Check spam folder or", /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        variant: "text",
        style: {
          textTransform: 'none'
        },
        onClick: handleResendCode,
        children: "Resend code"
      })]
    }), showError && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* InfoMessage */.$J, {
      "data-cy": "register-email-verification-error",
      variant: "error",
      hasBackground: true,
      message: errorMessage
    }), showInfoMessage && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* InfoMessage */.$J, {
      "data-cy": "register-email-verification-info",
      variant: "info",
      hasBackground: true,
      message: infoMessage
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Register_styles/* CTABackAndForthContainer */.uF, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
        size: "md",
        variant: "tertiary",
        onClick: function onClick() {
          return onPrevButtonClick();
        },
        "data-cy": "button-email-verification-back",
        sx: {
          padding: 0
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Register_styles/* ButtonContainer */.qO, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Register_styles/* ButtonIcon */.Ei, {
            icon: "ArrowLeft"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Register_styles/* ButtonLabel */.aN, {
            children: "Back"
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
        "data-cy": "register-email-verification-submit",
        onClick: handleVerifyEmail,
        disabled: isContinueButtonDisabled,
        loading: loading,
        children: " Verify Email "
      })]
    })]
  });
};

EmailVerification.displayName = "EmailVerification";
var EmailVerification_ComponentWithRouter = (0,router.withRouter)(EmailVerification);

;// CONCATENATED MODULE: ./src/components/Register/index.ts




/***/ }),

/***/ 72078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ useRegisterContext; },
/* harmony export */   "l": function() { return /* binding */ RegisterProvider; }
/* harmony export */ });
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16835);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



var RegisterContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(undefined);

var RegisterProvider = function RegisterProvider(_ref) {
  var children = _ref.children;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    user: {
      email: "",
      password: "",
      dateOfBirth: "",
      phoneNumber: "",
      emailPreferences: "AustraliaWide",
      accessibility: null,
      otherAccessibility: null,
      gender: null
    },
    address: {
      latitude: null,
      longitude: null,
      longLocation: null,
      shortLocation: null,
      detailsJson: "",
      country: "",
      unitOrApartmentNumber: null,
      street: "",
      suburb: null,
      state: null,
      postCode: ""
    },
    phoneNumberVerificationCode: ""
  }),
      registerInfo = _useState[0],
      setRegisterInfo = _useState[1];

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(null),
      _React$useState2 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_React$useState, 2),
      googleAddress = _React$useState2[0],
      setGoogleAddress = _React$useState2[1];

  var _React$useState3 = react__WEBPACK_IMPORTED_MODULE_0__.useState(false),
      _React$useState4 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_React$useState3, 2),
      isAccessibilitySet = _React$useState4[0],
      setIsAccessibilitySet = _React$useState4[1];

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(RegisterContext.Provider, {
    value: {
      registerInfo: registerInfo,
      setRegisterInfo: setRegisterInfo,
      googleAddress: googleAddress,
      setGoogleAddress: setGoogleAddress,
      isAccessibilitySet: isAccessibilitySet,
      setIsAccessibilitySet: setIsAccessibilitySet
    },
    children: children
  });
};

var useRegisterContext = function useRegisterContext() {
  var context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(RegisterContext);

  if (context === undefined) {
    throw new Error('useRegisterContext must be used within RegisterProvider');
  }

  return context;
};



/***/ }),

/***/ 85614:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ei": function() { return /* binding */ ButtonIcon; },
/* harmony export */   "K0": function() { return /* binding */ RegisterContainer; },
/* harmony export */   "Uh": function() { return /* binding */ CTAForthContainer; },
/* harmony export */   "aN": function() { return /* binding */ ButtonLabel; },
/* harmony export */   "gj": function() { return /* binding */ StyledBlueSpan; },
/* harmony export */   "qO": function() { return /* binding */ ButtonContainer; },
/* harmony export */   "uF": function() { return /* binding */ CTABackAndForthContainer; },
/* harmony export */   "wW": function() { return /* binding */ RegisterStepsContainer; }
/* harmony export */ });
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15861);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90948);
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46409);



var RegisterContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)("div")(function (_ref) {
  var theme = _ref.theme;
  return {
    position: 'relative',
    marginTop: theme.space._1000,
    width: "100%",
    maxWidth: "1440px",
    marginLeft: "auto",
    marginRight: "auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: theme.space._700,
    paddingBottom: "12.5rem"
  };
});
var StyledBlueSpan = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)("span")(function (_ref2) {
  var theme = _ref2.theme;
  return {
    color: theme.colors["blue.400"]
  };
});
var RegisterStepsContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)("div")(function (_ref3) {
  var theme = _ref3.theme;
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.space._600,
    width: "min-content",
    alignSelf: "strech",
    "@media (max-width: 600px)": {
      padding: "0 ".concat(theme.space._400),
      width: "100%"
    }
  };
});
var CTABackAndForthContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)("div")(function (_ref4) {
  var theme = _ref4.theme;
  return {
    display: "flex",
    paddingTop: theme.space._200,
    justifyContent: "space-between",
    alignItems: "center",
    gap: theme.space._600,
    alignSelf: "stretch"
  };
});
var CTAForthContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)("div")(function (_ref5) {
  var theme = _ref5.theme;
  return {
    display: "flex",
    paddingTop: theme.space._200,
    justifyContent: "flex-end",
    alignItems: "center",
    gap: theme.space._600,
    alignSelf: "stretch"
  };
});
var ButtonContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)("div")(function (_ref6) {
  var theme = _ref6.theme;
  return {
    display: "flex",
    paddingTop: theme.space._100,
    justifyContent: "center",
    alignItems: "center"
  };
});
var ButtonLabel = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function (_ref7) {
  var theme = _ref7.theme;
  return {
    color: theme.colors["neutral.50"],
    fontFamily: theme.fonts["default"],
    fontSize: theme.fontSizes.md,
    fontStyle: 'normal',
    fontWeight: theme.fontWeights.semibold,
    lineHeight: theme.lineHeights["short"]
  };
});
var ButtonIcon = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_icons__WEBPACK_IMPORTED_MODULE_0__/* .Icon */ .J)(function (_ref8) {
  var theme = _ref8.theme;
  return {
    width: theme.space._450,
    height: theme.space._450
  };
});

/***/ }),

/***/ 2892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ setGeocoderInfo; }
/* harmony export */ });
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50029);
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);


var geocoder;
var setGeocoderInfo = /*#__PURE__*/function () {
  var _ref = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(placeType, location) {
    var geocoderResponse, _addr$find, _addr$find2, _addr$find3, _addr$find4, _addr$find5, _addr$find6, _addr$find7, _addr$find8, info, addr, neighborhood, sublocality, locality;

    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!geocoder) {
              geocoder = new google.maps.Geocoder();
            } // const geocoder = { current: null };


            if (!(placeType == null || location == null)) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return");

          case 3:
            if (geocoder) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return");

          case 5:
            _context.next = 7;
            return geocoder.geocode({
              placeId: placeType.place_id
            });

          case 7:
            geocoderResponse = _context.sent;

            if (geocoderResponse && geocoderResponse.results && geocoderResponse.results.length > 0) {
              info = geocoderResponse.results[0];
              location.placeId = info.place_id;
              location.latitude = info.geometry.location.lat();
              location.longitude = info.geometry.location.lng();
              location.longLocation = info.formatted_address;
              location.shortLocation = "";
              location.detailsJson = "";
              addr = info.address_components;
              neighborhood = ((_addr$find = addr.find(function (a) {
                return a.types.includes('neighborhood');
              })) === null || _addr$find === void 0 ? void 0 : _addr$find.long_name) || "";
              sublocality = ((_addr$find2 = addr.find(function (a) {
                return a.types.includes('sublocality');
              })) === null || _addr$find2 === void 0 ? void 0 : _addr$find2.long_name) || "";
              locality = ((_addr$find3 = addr.find(function (a) {
                return a.types.includes('locality');
              })) === null || _addr$find3 === void 0 ? void 0 : _addr$find3.long_name) || "";
              location.country = ((_addr$find4 = addr.find(function (a) {
                return a.types.includes('country');
              })) === null || _addr$find4 === void 0 ? void 0 : _addr$find4.long_name) || "";
              location.unitOrApartmentNumber = ((_addr$find5 = addr.find(function (a) {
                return a.types.includes('street_number');
              })) === null || _addr$find5 === void 0 ? void 0 : _addr$find5.long_name) || "";
              location.street = ((_addr$find6 = addr.find(function (a) {
                return a.types.includes('route');
              })) === null || _addr$find6 === void 0 ? void 0 : _addr$find6.long_name) || "";
              location.suburb = neighborhood || sublocality || locality || "";
              location.state = ((_addr$find7 = addr.find(function (a) {
                return a.types.includes('administrative_area_level_1');
              })) === null || _addr$find7 === void 0 ? void 0 : _addr$find7.long_name) || "";
              location.postCode = ((_addr$find8 = addr.find(function (a) {
                return a.types.includes('postal_code');
              })) === null || _addr$find8 === void 0 ? void 0 : _addr$find8.long_name) || "";
            }

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function setGeocoderInfo(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

/***/ })

}]);